define([], function() {
    'use strict';
    return {
        isFunction: require('./util/is-function.js'),
        isArray: require('./util/is-array.js'),
        isBoolean: require('./util/is-boolean'),
        isPlainObject: require('./util/is-plain-object.js'),
        isWindow: require('./util/is-window.js'),
        isDate: require('./util/is-date'),
        isEmptyObject: require('./util/is-empty-object.js'),
        isNumber: require('./util/is-number'),
        isString: require('./util/is-string'),
        isRegex: require('./util/is-regex'),
        isUndefined: require('./util/is-undefined'),
        isObject: require('./util/is-object'),
        isDomElement: require('./util/is-dom-element'),
        getPrototype: require('./util/get-prototype.js'),
        noop: require('./util/noop'),
        url: require('./util/url.js'),
        parse: require('./util/parse'),
        each: require('./util/each'),
        filter: require('./util/filter'),
        any: require('./util/any'),
        has: require('./util/has'),
        toString: require('./util/to-string'),
        isEqual: require('./util/is-equal'),
        componentPath: require('./util/component-path'),
        string: require('./util/string'),
        merge: require('./util/merge'),
        map: require('./util/map'),
        css: require('./util/css'),
        intlNumberFormat: require('./util/intl-number-format'),
        intlDateFormat: require('./util/intl-date-format'),
        log: require('./util/log'),
        field: require('./util/field'),
        fastdom: require('../../vendor/fastdom/fastdom')
    };
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/util.js
 ** module id = 9
 ** module chunks = 0
 **/